export default __webpack_public_path__ + "static/media/chat-icon-active.b7ed1c69.svg";